import { useSyncExternalStore } from "react";

const mobileMediaQuery = "(max-width: 767px)";

const subscribeToMobileChanges = (onStoreChange: () => void) => {
  const mediaQueryList = window.matchMedia(mobileMediaQuery);
  mediaQueryList.addEventListener("change", onStoreChange);

  return () => {
    mediaQueryList.removeEventListener("change", onStoreChange);
  };
};

const getIsMobileSnapshot = () => window.matchMedia(mobileMediaQuery).matches;

const useIsMobile = () => {
  return useSyncExternalStore(
    subscribeToMobileChanges,
    getIsMobileSnapshot,
    () => false
  );
};

export default useIsMobile;
